import {
  apiRequest,
  cp3kPeriodCreate,
} from "../../../../../services/adapters/kepegawaian/cp3kService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      cp3kPeriodCreate,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
